import { defaultHttpClient } from '../../httpClient';
import type { GetRetailAdResponse } from './types';

export const getRetailAd = (adSlotId: number) => {
  return defaultHttpClient
    .request<GetRetailAdResponse>({
      method: 'GET',
      url: `/api/v2/retail_ad/${adSlotId}/`,
    })
    .then(result => result.data);
};
